<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M27.125 13.125C27.1236 11.7331 26.57 10.3986 25.5857 9.4143C24.6015 8.43005 23.2669 7.87646 21.875 7.87501H17.5219C17.2036 7.85642 11.6572 7.46595 6.37547 3.03626C6.12041 2.82205 5.80953 2.68508 5.47932 2.64143C5.14912 2.59779 4.81332 2.64928 4.51137 2.78986C4.20942 2.93044 3.95386 3.15428 3.77471 3.43506C3.59555 3.71585 3.50025 4.04194 3.5 4.37501V21.875C3.50005 22.2082 3.59519 22.5344 3.77426 22.8154C3.95333 23.0963 4.20888 23.3203 4.51088 23.461C4.81287 23.6017 5.14875 23.6533 5.47905 23.6097C5.80935 23.5661 6.12034 23.4291 6.37547 23.2149C10.5066 19.7499 14.7973 18.7567 16.625 18.4789V21.9483C16.6246 22.2367 16.6955 22.5207 16.8314 22.775C16.9673 23.0294 17.1639 23.2462 17.4037 23.4063L18.6069 24.208C18.8394 24.3632 19.1058 24.4604 19.3836 24.4915C19.6615 24.5227 19.9427 24.4868 20.2039 24.3868C20.465 24.2869 20.6984 24.1259 20.8844 23.9172C21.0705 23.7085 21.2039 23.4583 21.2734 23.1875L22.5608 18.3356C23.8238 18.1676 24.9828 17.5466 25.8223 16.5882C26.6618 15.6298 27.1247 14.3991 27.125 13.125ZM5.25 21.8674V4.37501C9.93234 8.30267 14.7252 9.29689 16.625 9.54189V16.7038C14.7273 16.9531 9.93563 17.9452 5.25 21.8674ZM19.5781 22.7424V22.7544L18.375 21.9527V18.375H20.7375L19.5781 22.7424ZM21.875 16.625H18.375V9.62501H21.875C22.8033 9.62501 23.6935 9.99376 24.3499 10.6501C25.0063 11.3065 25.375 12.1968 25.375 13.125C25.375 14.0533 25.0063 14.9435 24.3499 15.5999C23.6935 16.2563 22.8033 16.625 21.875 16.625Z"
      fill="#404040"
    />
  </svg>
</template>

<script>
export default {
  name: "MarketingIcon",
};
</script>
